'use strict';

const PricingController = {
  init: function () {
    this.params = new URL(window.location.href).searchParams;
    this.software = this.params.get("software");
    this.url = this.params.get("url");
    this.extensionMode = location.pathname.includes('extension');
    this.handleVisualLogic();
    this.extensionMode && this.handleAnalyticsForExtensions();
  },

  handleAnalyticsForExtensions: function () {
    const updateUrl = (element) => {
      if (element.href.includes('/checkout')) {
        element.href += `&software=${this.software}`;
        if (this.url) {
          element.href += `&url=${encodeURIComponent(this.url)}`;
        }
      }
    }
    const addTarget = (element) => {
      element.setAttribute("target", "_blank");
    }
    const apply = () => {
      Array.prototype.slice.call(document.getElementsByTagName('a')).forEach(a => {
        updateUrl(a);
        addTarget(a);
      });
    }
    this.software ? apply() : console.error('Software undefined, please check query string.');
  },

  handleVisualLogic: function () {
    if (document.getElementById('js_newPricingBlock')) {
      const current = 'tab2';
      const elem = document.querySelector('#js_newPricingBlock-switch');
      const btns = Array.prototype.slice.call(elem.children);
      showTab(current);
      setActiveBtn(btns[1], btns);

      elem.addEventListener('click', function (e) {
        const target = e.target;
        const { id } = target.dataset;
        if (id) {
          showTab(id);
          setActiveBtn(target, btns);
        }
        id && showTab(id);
      });

      function showTab(n) {
        const elems = document.querySelectorAll('.newPricingBlock-tab');
        elems.forEach(e => e.classList.add('hide'));
        document.querySelector(`#${n}`).classList.remove('hide');
      }

      function setActiveBtn(elem, btns) {
        btns.forEach(e => e.classList.remove('sw-active'));
        elem.classList.add('sw-active');
      }
    }
  }
}

module.exports = PricingController;




